import dayjs from 'dayjs';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import railsTranslations from '@/lib/i18n/translations.json';
import type { Locale } from '@/types';

// Transform Rails translations format to i18next format
const resources: Record<string, { translation: Record<string, unknown> }> = {};

for (const [locale, translations] of Object.entries(railsTranslations)) {
  resources[locale] = { translation: translations as Record<string, unknown> };
}

export const initI18n = (locale: Locale) => {
  dayjs.locale(locale);
  i18n.use(initReactI18next).init({
    resources,
    lng: locale,
    fallbackLng: 'fr',
    pluralSeparator: '.',
    interpolation: {
      escapeValue: false, // React already escapes values
      prefix: '%{',
      suffix: '}',
    },
  });
};
